import React, { memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import RoomDetail, { RoomDetailStateProps, RoomDetailDispatchProps, RoomDetailProps } from './roomsDetail';
import * as actions from './actions';
import { RoomModel } from '../../api/interfaces';
import { ApplicationState } from '../../store/rootReducer';
import { selectAccommodationsSelectItems } from '../accommodations';
import { selectFloorsSelectItems } from '../floors/selectors';
import { selectRoomTypesSelectItemsByAccomodationId } from '../roomTypes/selectors';

type RoomEditContainerStateProps = {} & RoomDetailStateProps;

type RoomEditContainerDispatchProps = {} & RoomDetailDispatchProps;

type RoomEditContainerProps = {} & RoomDetailProps & RoomEditContainerStateProps & RoomEditContainerDispatchProps;

const editInitialValues = {
  description: '',
  name: '',
  floorId: -1,
  accommodationId: -1,
  roomTypeId: -1
} as RoomModel;

const RoomEditContainer: React.FunctionComponent<RoomEditContainerProps> = memo(props => {
  console.debug('RoomEditContainer');

  const {
    errorMessage,
    requestInProgress,
    initialValues,
    roomTypes,
    accommodationsSelectItems,
    floorsSelectItems,
    modalDialog,
    modalDialogRoute,
    saveActionRequest,
    cancelActionRequest,
    selectRoomTypesSelectItemsByAccomodationId,
    loadDependenciesRequest
  } = props;

  return (
    <RoomDetail
      initialValues={initialValues}
      loadDependenciesRequest={loadDependenciesRequest}
      saveActionRequest={saveActionRequest}
      cancelActionRequest={cancelActionRequest}
      errorMessage={errorMessage}
      requestInProgress={requestInProgress}
      accommodationsSelectItems={accommodationsSelectItems}
      floorsSelectItems={floorsSelectItems}
      roomTypes={roomTypes}
      selectRoomTypesSelectItemsByAccomodationId={selectRoomTypesSelectItemsByAccomodationId}
      modalDialog={modalDialog}
      modalDialogRoute={modalDialogRoute}
    />
  );
});

const mapStateToProps = (state: ApplicationState, ownProps: any): RoomEditContainerStateProps => {
  return {
    initialValues: state.rooms.itemList.byId[ownProps.match.params.id],
    errorMessage: state.rooms.errorMessage,
    requestInProgress: state.rooms.requestInProgress,
    accommodationsSelectItems: selectAccommodationsSelectItems(state),
    floorsSelectItems: selectFloorsSelectItems(state),
    roomTypes: state.roomTypes.itemList.byId
  };
};

const mapDispatchToProps = (dispatch: Dispatch): RoomEditContainerDispatchProps => {
  return {
    ...bindActionCreators(
      {
        saveActionRequest: actions.saveItemAsync.request,
        cancelActionRequest: actions.cancelItemAsync.request,
        loadDependenciesRequest: actions.loadDependenciesAsync.request
      },
      dispatch
    ),
    selectRoomTypesSelectItemsByAccomodationId: selectRoomTypesSelectItemsByAccomodationId
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoomEditContainer);
